var map = {
	"./knife.png": "ddd9",
	"./machinegun.png": "eee5",
	"./pistol.png": "1ad9",
	"./rifle.png": "45eb",
	"./shotgun.png": "de93",
	"./smg.png": "bebe",
	"./sniperrifle.png": "fe21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db95";